import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { BreedInput, BreedOutput, WebAppRoutes } from "types/web-app";

export const breed = async (accessToken: string, input: BreedInput) => {
  try {
    const response = await fetchWithAuth(
      "/" + WebAppRoutes.BREED,
      accessToken,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(input),
      },
    );

    const data = (await response.json()) as ServiceResponse<BreedOutput>;

    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

